import { render, staticRenderFns } from "./feriados.vue?vue&type=template&id=1e4e3c1d&scoped=true&"
import script from "./feriados.vue?vue&type=script&lang=js&"
export * from "./feriados.vue?vue&type=script&lang=js&"
import style0 from "./feriados.vue?vue&type=style&index=0&id=1e4e3c1d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4e3c1d",
  null
  
)

export default component.exports